import { Tag } from "antd";
import { APIresponse } from "../../../model/client/response";

export const ProductCategoriesDetail = (category: APIresponse.CategoryDTO) => {
    return (
        <>
        <>
            <Tag color={"green"}>
                {category.name}
            </Tag>
        </>
        </>
    )
}